import { Observable } from 'rxjs';
import { CheckReservation } from '../models/check-body.model';
import { CheckReservationResponse } from '../models/check-response.model';

export abstract class CheckReservationRepository {
    abstract checkReservation(
        checkReservation: CheckReservation,
    ): Observable<CheckReservationResponse>;
}
